import * as React from "react";
import { useEffect, useState } from "react";
import { BOOKINGTYPE } from "shared/constants/enums";
import Carousel, { ResponsiveType } from "react-multi-carousel";
import InputMask from "react-input-mask";
import "react-multi-carousel/lib/styles.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import "./appointment.less";
import moment from "moment-timezone";
import { BranchModel } from "states/branch/branch.models";
import { getBranchList } from "states/branch/branch.api";
import { SalonServiceModel } from "states/salon-service/salon-service.models";
import { getServiceList } from "states/salon-service/salon-service.api";
import { SalonServiceCategoryModel } from "states/salon-service-category/salon-service-category.models";
import { getServiceCategoryList } from "states/salon-service-category/salon-service-category.api";
import {
  formatMinute,
  formatMoney,
  removeFormatPhone,
} from "shared/plugins/string-helper";
import {
  AppointmentModel,
  AppointmentServiceModel,
  CreatedAppointmentModel,
  HourItemModel,
} from "states/appointment/appointment.models";
import { getStaffListByServiceIds } from "states/salon-staff/salon-staff.api";
import { SalonStaffModel } from "states/salon-staff/salon-staff.models";
import {
  momentDateFormat,
  momentDateTimeFormat,
} from "shared/plugins/localization";
import {
  createAppointment,
  getHourList,
} from "states/appointment/appointment.api";
import {
  setLoading,
  showConfirmModal,
} from "states/global-value/global-value.slice";
import { DefaultErrorMessage } from "shared/constants/message";
import { useDispatch } from "react-redux";
export interface IAppointmentProps {}

export function Appointment(props: IAppointmentProps) {
  const dispatch = useDispatch();
  const [model, setModel] = useState<AppointmentModel>({
    appointmentType: BOOKINGTYPE.Individual,
    services: [] as AppointmentServiceModel[],
    requestedDate: moment().format(momentDateFormat()),
  } as AppointmentModel);
  const [branchList, setBranchList] = useState<BranchModel[]>([]);
  const [selectedBranch, setSelectedBranch] = useState<BranchModel>();
  const [serviceList, setServiceList] = useState<SalonServiceModel[]>([]);
  const [serviceCategoryList, setServiceCategoryList] = useState<
    SalonServiceCategoryModel[]
  >([]);
  const [staffList, setStaffList] = useState<SalonStaffModel[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<number>();

  const [hourList, setHourList] = useState<HourItemModel[]>([]);
  const [selectedHour, setSelectedHour] = useState<HourItemModel>();

  const responsive: ResponsiveType = {
    desktop: {
      breakpoint: { max: 3000, min: 464 },
      items: 5,
      slidesToSlide: 2,
      paritialVisibilityGutter: 13,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3,
      slidesToSlide: 2,
      paritialVisibilityGutter: 15,
    },
  };

  const calendarResponsive: ResponsiveType = {
    desktop: {
      breakpoint: { max: 3000, min: 464 },
      items: 6,
      slidesToSlide: 2,
      paritialVisibilityGutter: 10,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3,
      slidesToSlide: 2,
      paritialVisibilityGutter: 15,
    },
  };

  const renderHourItem = (hourItem: HourItemModel) => {
    return (
      hourItem && (
        <div
          className={`hour-item border border-black h-12 flex justify-center items-center my-2 ${
            selectedHour &&
            selectedHour.hours === hourItem.hours &&
            selectedHour.minutes == hourItem.minutes
              ? "selected"
              : ""
          } ${hourItem.disabled ? "disabled" : ""}`}
          onClick={() => {
            if (!hourItem.disabled) {
              setSelectedHour({ ...hourItem });
            }
          }}
        >
          {hourItem.displayedText}
        </div>
      )
    );
  };

  const renderHourList = () => {
    const result: any[] = [];
    let index = 0;
    while (index < hourList.length) {
      result.push(
        <div>
          {renderHourItem(hourList[index])}
          {index + 1 < hourList.length && renderHourItem(hourList[index + 1])}
          {index + 2 < hourList.length && renderHourItem(hourList[index + 2])}
        </div>
      );
      index += 3;
    }
    return result;
  };

  const loadBranchList = async () => {
    const res = await getBranchList();
    setSelectedBranch(res.data[0]);
    setBranchList(res.data);
  };

  const loadServiceList = async () => {
    const res = await getServiceList(
      selectedBranch?.id ?? 0,
      model.requestedStaff
    );
    setServiceList(res.data);
  };

  const loadServiceCategoryList = async () => {
    const res = await getServiceCategoryList(selectedBranch?.id ?? 0);
    setServiceCategoryList(
      res.data.sort((a, b) => {
        a.sort = a.sort ?? 0;
        b.sort = b.sort ?? 0;
        return a.sort - b.sort;
      })
    );
  };

  const loadStaffList = async () => {
    const res = await getStaffListByServiceIds({
      branchId: selectedBranch?.id ?? 0,
      serviceIds: [],
    });
    setStaffList(res.data);
  };

  const loadHourList = async () => {
    const res = await getHourList({
      branchId: selectedBranch?.id ?? 0,
      selectedDate: model.requestedDate,
      selectedServiceIds: model.services.map((m) => m.id),
      selectedStaff: model.requestedStaff,
    });
    setHourList(res.data);
  };

  const removeService = (serviceId: number) => {
    setModel({
      ...model,
      services: model.services.filter((m) => m.id != serviceId),
    });
  };

  const submitAppointment = async () => {
    if (!selectedBranch || !selectedHour) {
      alert("Please select date and time");
      return;
    }
    const payload = {
      appointmentType: model.appointmentType,
      branchId: selectedBranch.id,
      firstName: model.firstName,
      lastName: model.lastName,
      phone: model.phone,
      email: model.email,
      numberOfPeople: model.numberOfPeople,
      requestedStaff: model.requestedStaff,
      serviceIds: model.services.map((m) => m.id),
      requestedTime: moment
        .tz(
          model.requestedDate,
          momentDateTimeFormat(),
          selectedBranch.ianaTimeZone
        )
        .add(selectedHour.hours, "hours")
        .add(selectedHour.minutes, "minutes")
        .toDate(),
    } as CreatedAppointmentModel;
    dispatch(setLoading(true));
    try {
      await createAppointment(payload);
      dispatch(
        showConfirmModal({
          isModal: true,
          message: (
            <>
              Your appointment request has been successfully sent to{" "}
              {selectedBranch.name}
              <br />
              We will contact you to confirm your appointment request soon
            </>
          ),
          onClose: () => {
            dispatch(showConfirmModal({ isModal: false }));
            document.location.href = "/booking";
          },
          onYes: () => {
            dispatch(showConfirmModal({ isModal: false }));
            document.location.href = "/booking";
          },
        })
      );
    } catch (error) {
      alert(error?.response?.data?.error?.message ?? DefaultErrorMessage);
    }
    dispatch(setLoading(false));
  };

  useEffect(() => {
    loadBranchList();
  }, []);

  useEffect(() => {
    if (selectedBranch) {
      loadStaffList();
      loadServiceList();
      loadServiceCategoryList();
    }
  }, [selectedBranch]);

  useEffect(() => {
    if (model.services) {
      setModel({
        ...model,
        totalAmount: model.services.reduce((a, b) => {
          return a + (b.price ?? 0);
        }, 0),
        totalMinutes: model.services.reduce((a, b) => {
          return a + (b.duration ?? 0);
        }, 0),
        pricePlus: model.services.filter((m) => m.pricePlus).length > 0,
      });
    }
  }, [model.services.length]);

  useEffect(() => {
    setSelectedHour(undefined);
    if (model.services.length > 0) {
      loadHourList();
    } else {
      setHourList([]);
    }
  }, [model.services.length, model.requestedDate, model.requestedStaff]);

  useEffect(() => {
    if (
      model.requestedStaff &&
      staffList.filter((m) => m.id === model.requestedStaff).length === 0
    ) {
      setModel({ ...model, requestedStaff: undefined });
    }
  }, [staffList.length]);

  useEffect(() => {
    if (model.appointmentType === BOOKINGTYPE.Group) {
      setModel({ ...model, requestedStaff: undefined });
    }
  }, [model.appointmentType]);

  useEffect(() => {
    loadServiceList();
    if (model.services.length > 0) {
      setModel({ ...model, services: [] });
    }
  }, [model.requestedStaff]);
  return (
    <React.Fragment>
      {model ? (
        <div id="booking-page">
          <div className="bg-gray-700 flex justify-center">
            <div className="booking-container">
              <div className="text-white font-bold py-4 text-3xl">
                REQUEST AN APPOINTMENT
              </div>
              <div className="flex">
                <button
                  className={
                    model.appointmentType === BOOKINGTYPE.Individual
                      ? "py-2 px-8 text-white bg-primary uppercase font-bold mr-2 w-auto inline-block focus:outline-none"
                      : "py-2 px-8 text-primary bg-white uppercase font-bold mr-2 w-auto inline-block focus:outline-none hover:text-white hover:bg-primary transition-all"
                  }
                  onClick={(e) => {
                    setModel({
                      ...model,
                      appointmentType: BOOKINGTYPE.Individual,
                    });
                  }}
                >
                  Individual
                </button>
                <button
                  className={
                    model.appointmentType === BOOKINGTYPE.Group
                      ? "py-2 px-8 text-white bg-primary uppercase font-bold w-auto inline-block focus:outline-none"
                      : "py-2 px-8 text-primary bg-white uppercase font-bold w-auto inline-block focus:outline-none hover:text-white hover:bg-primary transition-all"
                  }
                  onClick={(e) => {
                    setModel({
                      ...model,
                      appointmentType: BOOKINGTYPE.Group,
                    });
                  }}
                >
                  Group
                </button>
              </div>
            </div>
          </div>
          {model.appointmentType === BOOKINGTYPE.Individual && (
            <div className="bg-gray-100">
              <div className="bg-gray-200 text-black font-bold py-3 text-2xl uppercase text-center">
                SELECT OUR STAFF
              </div>
              <div className="flex justify-center py-6">
                <div className="booking-container flex divide-x">
                  <div
                    className={`flex flex-col items-center mr-2 w-16 ${
                      model.requestedStaff ? "" : "staff-selected"
                    }`}
                    onClick={() => {
                      if (model.requestedStaff) {
                        setModel({ ...model, requestedStaff: undefined });
                      }
                    }}
                  >
                    <div className="staff-avatar rounded-full bg-white text-3xl flex items-center justify-center">
                      <i className="fa fa-user"></i>
                    </div>
                    <span className="text-center">DEFAULT</span>
                  </div>
                  <Carousel
                    responsive={responsive}
                    arrows={false}
                    draggable
                    focusOnSelect={false}
                    infinite={false}
                    minimumTouchDrag={80}
                    autoPlaySpeed={3000}
                    partialVisible
                    className="pl-2 w-full"
                    itemClass="select-none px-2"
                  >
                    {staffList.map((staff) => (
                      <div
                        key={staff.id}
                        className={`flex flex-col items-center ${
                          model.requestedStaff === staff.id
                            ? "staff-selected"
                            : ""
                        }`}
                        onClick={() => {
                          if (model.requestedStaff !== staff.id) {
                            setModel({ ...model, requestedStaff: staff.id });
                          }
                        }}
                      >
                        <div className="staff-avatar rounded-full overflow-hidden bg-white text-3xl flex items-center justify-center">
                          {staff.avatar ? (
                            <img draggable={false} src={staff.avatar} />
                          ) : (
                            <i className="fa fa-user"></i>
                          )}
                        </div>
                        <span className="text-center">{staff.name}</span>
                      </div>
                    ))}
                  </Carousel>
                </div>
              </div>
            </div>
          )}
          <div className="bg-gray-100">
            <div className="bg-gray-200 text-black font-bold py-3 text-2xl uppercase text-center">
              SELECT SERVICES
            </div>
            <div className="flex flex-col items-center py-6">
              <div className="booking-container bg-white mb-4">
                {serviceCategoryList.map((category) => {
                  const services = serviceList
                    .filter((m) => m.mainCategoryId == category.id)
                    .sort((a, b) => {
                      a.sort = a.sort ?? 0;
                      b.sort = b.sort ?? 0;
                      return a.sort - b.sort;
                    });
                  return (
                    <div
                      key={category.slug + category.id}
                      className={`category-item border border-gray-300 ${
                        selectedCategoryId === category.id ? "collapsed" : ""
                      }`}
                    >
                      <div
                        className={`p-4 flex justify-between items-center cursor-pointer`}
                      >
                        <div
                          onClick={() => {
                            setSelectedCategoryId(category.id);
                          }}
                        >
                          {selectedCategoryId === category.id ? (
                            <i className="fa fa-angle-up mr-2"></i>
                          ) : (
                            <i className="fa fa-angle-down mr-2"></i>
                          )}
                          <span>{category.name}</span>
                        </div>
                        <span>
                          {services.length <= 0
                            ? ""
                            : services.length > 1
                            ? `${services.length} services`
                            : `${services.length} service`}
                        </span>
                      </div>
                      <div className="itemlst">
                        {services.map((service, index) => (
                          <div
                            key={service.slug + service.id}
                            className="p-4 flex justify-between items-center border-t"
                          >
                            <span>{service.name}</span>
                            <div className="flex items-center">
                              <span className="font-bold">
                                {formatMoney(service.price, 2, ".", ",", "$")}
                                {service.pricePlus && "+"}
                              </span>
                              <div className="w-20 text-right">
                                {model.services.find(
                                  (m) => m.id === service.id
                                ) ? (
                                  <button
                                    className="btn bg-gray-400 text-white hover:bg-primary transition ml-2"
                                    onClick={() => {
                                      removeService(service.id);
                                    }}
                                  >
                                    <i className="fa fa-close"></i>
                                  </button>
                                ) : (
                                  <button
                                    onClick={() => {
                                      model.services.push({
                                        id: service.id,
                                        name: service.name,
                                        duration: service.duration,
                                        price: service.price,
                                        pricePlus: service.pricePlus,
                                      });
                                      setModel({ ...model });
                                    }}
                                    className="btn btn-primary ml-2"
                                  >
                                    Select
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="booking-container bg-gray-200 p-4">
                <div className="grid grid-cols-1 divide-y divide-gray-400 divide-dotted">
                  {model.services.map((service) => (
                    <div className="flex justify-between  py-2">
                      <span>{service.name}</span>
                      <div>
                        <span className="mr-2">
                          {formatMinute(service.duration)}
                        </span>
                        <i
                          onClick={() => {
                            removeService(service.id);
                          }}
                          className="fa fa-close cursor-pointer"
                        ></i>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="flex flex-col items-center">
                  <span className="text-2xl font-bold">
                    TOTAL: {formatMoney(model.totalAmount, 2, ".", ",", "$")}
                    {model.pricePlus && "+"}
                  </span>
                  <span>{formatMinute(model.totalMinutes)}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray-100">
            <div className="bg-gray-200 text-black font-bold py-3 text-2xl uppercase text-center">
              SELECT DATE AND TIME
            </div>
            <div className="flex justify-center py-6">
              <div className="booking-container">
                <div className="flex items-center mb-4">
                  <span className="font-bold mr-2">SELECT YOUR DATE:</span>
                  <DatePicker
                    wrapperClassName="flex-auto"
                    className="w-full p-2 border"
                    locale="es"
                    dateFormat="MM/DD/YYYY"
                    value={model.requestedDate}
                    onChange={(date) => {
                      if (date) {
                        setModel({
                          ...model,
                          requestedDate: moment(date as Date).format(
                            momentDateFormat()
                          ),
                        });
                      }
                    }}
                    withPortal
                  />
                </div>
                {hourList.length > 0 ? (
                  <Carousel
                    className="bg-white"
                    responsive={calendarResponsive}
                    arrows={false}
                    draggable
                    focusOnSelect={false}
                    infinite={false}
                    minimumTouchDrag={80}
                    autoPlaySpeed={3000}
                    partialVisible
                    itemClass="select-none px-1"
                  >
                    {renderHourList()}
                  </Carousel>
                ) : (
                  <div className="text-center text-primary bg-white p-4 font-bold">
                    {model.services.length > 0
                      ? "Please select another date"
                      : "Please select services"}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="bg-gray-100">
            <div className="bg-gray-200 text-black font-bold py-3 text-2xl uppercase text-center">
              CUSTOMER INFORMATION
            </div>
            <div className="flex justify-center py-6">
              <div className="booking-container">
                <div className="grid grid-cols-2 gap-4 mb-4">
                  <input
                    className="p-2 border"
                    placeholder="First Name*"
                    value={model.firstName}
                    onChange={(e) => {
                      setModel({
                        ...model,
                        firstName: e.target.value
                          ? e.target.value.toUpperCase()
                          : "",
                      });
                    }}
                  ></input>
                  <input
                    className="p-2 border"
                    placeholder="Last Name*"
                    value={model.lastName}
                    onChange={(e) => {
                      setModel({
                        ...model,
                        lastName: e.target.value
                          ? e.target.value.toUpperCase()
                          : "",
                      });
                    }}
                  ></input>
                </div>
                <div className="grid mb-4">
                  <InputMask
                    className="p-2 border"
                    placeholder="Phone number*"
                    mask="999-999-9999"
                    value={model.phone}
                    onChange={(e) => {
                      setModel({
                        ...model,
                        phone: removeFormatPhone(e.target.value),
                      });
                    }}
                  ></InputMask>
                </div>
                <div className="grid mb-4">
                  <input
                    className="p-2 border"
                    placeholder="Email"
                    value={model.email}
                    onChange={(e) => {
                      setModel({
                        ...model,
                        email: e.target.value
                          ? e.target.value.toLowerCase()
                          : "",
                      });
                    }}
                  ></input>
                </div>
                {model.appointmentType === BOOKINGTYPE.Group && (
                  <div className="grid mb-4">
                    <input
                      type="number"
                      className="p-2 border"
                      placeholder="Number of people*"
                      value={model.numberOfPeople}
                      onChange={(e) => {
                        setModel({
                          ...model,
                          numberOfPeople: e.target.value
                            ? e.target.valueAsNumber
                            : undefined,
                        });
                      }}
                    ></input>
                  </div>
                )}
                <button
                  onClick={submitAppointment}
                  className="btn btn-primary w-full font-bold"
                >
                  REQUEST AN APPOINTMENT
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div />
      )}
    </React.Fragment>
  );
}
